/**
 * This code mostly copied from these files from `react-native-drax`:
 * - https://github.com/nuclearpasta/react-native-drax/blob/7a65698fb7672ee68764dd0dfcefe70b022850a7/src/hooks/useDraxId.ts
 * - https://github.com/nuclearpasta/react-native-drax/blob/7a65698fb7672ee68764dd0dfcefe70b022850a7/src/math.ts
 * Therefore the code contained in this file is subject to the MIT License.
 *
 * MIT License
 *
 * Copyright (c) 2019-2020 Nuclear Pasta, LLC
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { useState } from "react";

export const generateRandomId = () => `${Math.random().toString(36).substr(2)}${Math.random().toString(36).substr(2)}`;

// Return explicitId, or a consistent randomly generated identifier if explicitId is falsy.
export const useDraxId = (explicitId?: string) => {
  // A generated unique identifier for this view, for use if id prop is not specified.
  const [randomId] = useState(generateRandomId);
  // We use || rather than ?? for the return value in case explicitId is an empty string.
  return explicitId || randomId;
};
